import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=5ff3a7f2&scoped=true"
import script from "./Claims.vue?vue&type=script&lang=js"
export * from "./Claims.vue?vue&type=script&lang=js"
import style0 from "./Claims.vue?vue&type=style&index=0&id=5ff3a7f2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3a7f2",
  null
  
)

export default component.exports